import React from 'react';
import { ArrowRight } from 'lucide-react';
import AnimatedElement from '../utils/AnimatedElement';

const CTASection = () => {
  return (
    <section className="py-24 relative overflow-hidden">
      <div className="container mx-auto px-6 relative z-10">
        <AnimatedElement animation="fadeIn" duration={0.6}>
          <div className="glass-card p-10 md:p-16 text-center max-w-4xl mx-auto">
            
            <AnimatedElement animation="slideUp" delay={0.2}>
              <h2 className="text-3xl md:text-4xl font-bold mb-6">
                Let's Build Something Together
              </h2>
            </AnimatedElement>
            
            <AnimatedElement animation="slideUp" delay={0.3}>
              <p className="text-muted-foreground max-w-2xl mx-auto mb-10 text-base">
                Whether you're looking to deploy ML models, build data pipelines, or connect IoT devices, 
                we can help. Schedule a call to discuss your project.
              </p>
            </AnimatedElement>
            
            <AnimatedElement animation="slideUp" delay={0.4}>
              <div className="flex flex-col sm:flex-row justify-center gap-6">
                <a
                  href="https://fictionalstream.zohobookings.in/#/406146000000042072"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="glass-button-primary px-8 py-3 text-base font-medium group"
                >
                  Schedule a Call
                  <ArrowRight className="ml-2 h-4 w-4 inline-block transition-transform duration-300 group-hover:translate-x-1" />
                </a>
                
                {/* Comment out the Link/button to /case-studies */}
                {/* <motion.div whileHover={{ scale: 1.05 }} whileTap={{ scale: 0.98 }}>
                  <Link 
                    to="/case-studies" 
                    onClick={() => window.scrollTo(0, 0)}
                    className="glass-button px-8 py-3 text-base font-light"
                  >
                    Explore Case Studies
                  </Link>
                </motion.div> */}
              </div>
            </AnimatedElement>
          </div>
        </AnimatedElement>
      </div>
    </section>
  );
};

export default CTASection;
